import { initializeApp } from 'firebase/app';
import {
  getFirestore,
  collection,
  addDoc,
  doc,
  setDoc,
  query,
  where,
  getDocs,
  serverTimestamp,
} from 'firebase/firestore';

// TODO: fill in with your actual Firebase project config
// You can get this from your Firebase console (Web app settings)
const firebaseConfig = {
    apiKey: "AIzaSyAmkPT2FlRe6Z8_wePrZmlqPUDJDt2Y3wA",
    authDomain: "escape-room-6dce5.firebaseapp.com",
    projectId: "escape-room-6dce5",
    appId: "1:348209452174:web:6ccdb0eae95abc0465a5df"
};

// Initialize Firebase app and Firestore (simple, single-app setup)
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

// Quick-and-dirty helper: call this whenever you want to log something.
// It returns a promise but EscapeRoom can just fire-and-forget.
export async function logProgress(data) {
  try {
    await addDoc(collection(db, 'escapeRoomProgress'), {
      ...data,
      createdAt: new Date().toISOString(),
    });
  } catch (err) {
    // Intentionally swallow errors so logging never breaks gameplay
    // eslint-disable-next-line no-console
    console.error('Error logging progress', err);
  }
}

// ---- Presence helpers (who is on which station) ----

// Update or create a presence document for a given session.
export async function updatePresence({
  sessionId,
  stationKey,
  stationId,
  isBonus,
  studentFirstName,
  studentLastInitial,
}) {
  if (!sessionId || !stationKey) return;

  try {
    const ref = doc(db, 'escapeRoomPresence', sessionId);
    await setDoc(
      ref,
      {
        sessionId,
        stationKey,
        stationId,
        isBonus,
        studentFirstName,
        studentLastInitial,
        updatedAt: serverTimestamp(),
      },
      { merge: true }
    );
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('Error updating presence', err);
  }
}

// Fetch classmates currently on the same stationKey (one-shot).
export async function fetchStationPresence(stationKey) {
  if (!stationKey) return [];

  const q = query(
    collection(db, 'escapeRoomPresence'),
    where('stationKey', '==', stationKey)
  );

  const snapshot = await getDocs(q);
  const classmates = [];
  snapshot.forEach((docSnap) => {
    classmates.push({ id: docSnap.id, ...docSnap.data() });
  });
  return classmates;
}


